
export const YOUTUBE_VIDEO_STATUSES = {
  PLAYING: "Playing...",
  PAUSED: "Paused...",
  ENDED: "",
  RESET: "Reset...",
};
